import React from 'react'
import ReactDOM from 'react-dom'
import { BrowserRouter } from 'react-router-dom'
import { Provider } from 'react-redux'
import './scss/index.scss'
import store from './configure-store'


import Routes from './routes'
import * as serviceWorker from './serviceWorker'


export {
  // export store and history here to use them 
  // outside react components
  store,
}

ReactDOM.render(
  (<Provider store={store}>
    <BrowserRouter>
      <Routes />
    </BrowserRouter>
  </Provider>),
  document.getElementById(`root`)
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
